import $ from 'cash-dom';

export { getJqContainer };

function getJqContainer(selector) {
    return $(selector);
}
